import {AfterViewInit, Component, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormControl} from '@angular/forms';
import {MatOption} from '@angular/material/core';
import {DownloadDataService} from '../../../core/services/download-data.service';
import {Country} from '../../../kf-data-entry/models/country.interface';
import {saveAs} from 'file-saver';
import {AuthService} from '../../../core/services/auth.service';

@Component({
  selector: 'app-download-kf-data',
  templateUrl: './download-kf-data.component.html',
  styleUrls: ['./download-kf-data.component.scss']
})
export class DownloadKfDataComponent implements OnInit, AfterViewInit {

  years!: number[];
  countries!: Country[];

  downloadDataForm = this.formBuilder.group({
    years: [''],
    countries: [''],
  });

  get yearsControl(): FormControl {
    return this.downloadDataForm.get('years') as FormControl;
  }
  get countriesControl(): FormControl {
    return this.downloadDataForm.get('countries') as FormControl;
  }

  @ViewChild('allSelected') private allSelected!: MatOption;
  @ViewChild('allCountrySelected') private allCountrySelected!: MatOption;

  constructor(private readonly formBuilder: FormBuilder,
              private readonly downloadDataService: DownloadDataService,
              private readonly authService: AuthService) { }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    if (this.allSelected) {
      this.downloadDataService.getAllYears().subscribe(data => {
        this.years = data;
        this.allSelected.select();
        this.toggleAllYearsSelection();
        this.toggleAllCountriesSelection();
      });
    }
    if (this.allCountrySelected) {
      this.downloadDataService.getAllCountries().subscribe(data => {
        this.countries = data;
        this.allCountrySelected.select();
        this.toggleAllYearsSelection();
        this.toggleAllCountriesSelection();
      });
    }
  }

  toggleYearPerOne(): void {
    if (this.allSelected.selected) {
      this.allSelected.deselect();
      return;
    }
    if (this.yearsControl.value.length === this.years.length) {
      this.allSelected.select();
    }
  }

  toggleCountryPerOne(): void {
    if (this.allCountrySelected.selected) {
      this.allCountrySelected.deselect();
      return;
    }
    if (this.countriesControl.value.length === this.countries.length) {
      this.allCountrySelected.select();
    }

  }

  toggleAllYearsSelection(): void {
    if (this.allSelected.selected) {
      this.yearsControl
        .patchValue([...this.years.map(item => item), 0]);
    } else {
      this.yearsControl.patchValue([]);
    }

    if (this.allCountrySelected.selected) {
      this.countriesControl
        .patchValue([...this.countries.map(item => item.id), 0]);
    } else {
      this.countriesControl.patchValue([]);
    }
  }

  toggleAllCountriesSelection(): void {
    if (this.allCountrySelected.selected) {
      this.countriesControl
        .patchValue([...this.countries.map(item => item.id), 0]);
    } else {
      this.countriesControl.patchValue([]);
    }
  }

  downloadData(): void {
    this.downloadDataService
      .downloadExcel({years: this.yearsControl.value, countries: this.countriesControl.value})
      .subscribe(response => {
        const userSystem = this.authService.getSystem();
        this.downloadFile(response, `kf_data-${userSystem ? userSystem + '-' : ''}${new Date(Date.now()).toISOString()}.xlsx`);
      });
  }

  private downloadFile(response: any, filename: string): void {
    const blob = new Blob([response.body], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
    saveAs(blob, filename);
  }

}
